<template>
  <div class="travelItinerary">
    <!-- <div  v-if="lineTripList.length > 0"> -->
      <van-list
        class="wrapper-box"
        v-model="loading"
        :finished="finished"
        :finished-text="finishedText"
        @load="loadMore"
      >
      <!-- @click="$router.push({path: '/travelAgency/tripDetail',query:{tripId: lists.teamNo} })" -->
      <div
          v-for="(lists,index) in lineTripList"
          :key="index"
          @click="goItineraryDetail(lists.teamNo)"
          class="list-item-box">
        <div
          class="items-box"
        >
          <div class="info-box">
            <div class="title-box">
              <div class="title">{{lists.routeName}}</div>
              <div class="tag" v-if="Date.parse(new Date()) < (Date.parse(lists.teamEndDate))">正在出团</div>
            </div>
            <div class="date-box">
              <div
                class="dates"
              >{{(lists.teamStartDate).substring(0,10)}} 至 {{(lists.teamEndDate).substring(0,10)}}</div>
              <div class="address">{{lists.teamStartPlace}}</div>
            </div>
            <div class="numbers">行程单号 : {{lists.teamNo}}</div>
          </div>
          <div class="lookmore">
            <img src="../../assets/travelAgency/ic_righticon.png" alt class="right-icon" />
          </div>
        </div>
         <rline  v-if="index < lineTripList.length - 1"></rline>
      </div>
      </van-list>
    </div>
  <!-- </div> -->
</template>
<script>
    import api from '../../service/modules/travel';
    import rline from './components/line';
    import apimessage from '../../service/modules/message'
    import { navigateToItineraryUniversal } from '@/router/navigate';
    export default {
        components: {
            rline
        },

        data () {
            return {
                lineTripList: [],
                loading: false,
                finished: false,
                finishedText: '没有更多',
                pagination: { total: 0, current_page: 0, page_size: 10 },
                guideId: 0,
                travelId: ''
            };
        },

        computed: {},

        watch: {},

        methods: {
            // 消息单条已读
            onMessageReadOne (isRead, id) {
                if (isRead === 'false') {
                    apimessage.messageReadOne({ messageId: id }).then(res => {
                        localStorage.setItem('messageId', id)
                    })
                }
            },
            loadMore () {
                this.getTripList()
            },
            // 旅行社行程列表
            getTripList () {
                let data = {}
                if (this.guideId !== 0) {
                    data = { guideId: this.guideId, p: parseInt(this.pagination.current_page) + 1 }
                } else {
                    data = { travelId: this.travelId, p: parseInt(this.pagination.current_page) + 1 }
                }
                api
                    .traveltripList(data)
                    .then(res => {
                        if (res.ret === 0) {
                            this.pagination = res.data.pagination;
                            this.lineTripList = [...this.lineTripList, ...res.data.list];
                            this.loading = false;
                            if (
                                this.pagination.current_page >= Math.ceil(this.pagination.total / this.pagination.page_size)
                            ) {
                                this.finished = true;
                            }
                        }
                    });
            },
            goItineraryDetail(id) {
              navigateToItineraryUniversal(id, 'team-supervision')
            }
        },

        mounted () {
            let messageId = this.$route.query.messageId || ''
            let isRead = this.$route.query.isRead || 'true'
            this.onMessageReadOne(isRead, messageId)
        },
        created () {
            this.guideId = this.$route.query.guideId || 0;
            this.travelId = this.$route.query.travelId
        }
    };
</script>
<style scoped lang="less">
.travelItinerary {
  width: 100%;
  min-height: 100%;
  background: rgba(251, 251, 251, 1);
  .wrapper-box {

    .list-item-box{
      box-sizing: border-box;
      padding: 0 12px;
      background: #fff;
    }

    .items-box {
      box-sizing: border-box;
      padding: 16px 0;
      display: flex;
      align-items: flex-end;

      .info-box {
        flex: 1;

        .title-box {
          display: flex;
          align-items: center;
          margin-bottom: 12px;
          .title {
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            line-height: 18px;
            margin-right: 12px;
          }
          .tag {
            background: rgba(54, 179, 116, 1);
            border-radius: 1px;
            font-size: 10px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            line-height: 12px;
            box-sizing: border-box;
            padding: 0 4px;
          }
        }
        .date-box {
          display: flex;
          align-items: center;
          margin-bottom: 4px;

          .dates {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
            line-height: 12px;
            margin-right: 12px;
          }
          .address {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
            line-height: 12px;
          }
        }
        .numbers {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          line-height: 12px;
        }
      }
      .lookmore {
        height: 12px;
        display: flex;
        align-items: center;
        overflow: hidden;
        .right-icon {
          width: 12px;
          height: 12px;
        }
      }
    }
  }
}
</style>
